<template>
  <header class="main-header" :style="myBgColorStyle">
    <div class="content-wrapper">
      <div class="row">
        <div class="col-xs-2 col-md-3 header-controls">
          <div class="header-item-left header-item-left-menu">
            <div class="menu-img">
              <!-- <img v-bind:src="logoURL" width='60%' /> -->
              <img src="../assets/icons/Suez_opened.png" />
            </div>
          </div>
          <div
            class="header-item-left header-item-left-menu"
            style="padding-left: 20px"
          >
            <div class="menu-img">
              <!-- <img v-bind:src="logoURL" width='60%' /> -->
              <img src="../assets/onconnectdmprod.png" />
            </div>
          </div>
        </div>

        <div class="col-xs-6 col-md-9 header-links">
          <div class="hidden-xs">
            <div class="header-item">
              <langSwitcher></langSwitcher>
            </div>
            <div class="header-item menu-header-separator">
              <router-link to="/logout">
                <span :style="myTxtColorStyle"
                  ><img height="20" src="../assets/logout.png"
                /></span>
              </router-link>
            </div>

            <div class="header-item">
              <img height="20" src="../assets/login.png" />
            </div>
            <div class="header-item">
              <!-- <langSwitcher></langSwitcher> -->MOA740
            </div>
            <div class="header-item menu-header-separator"></div>
            <div class="header-item">
              <!-- <langSwitcher></langSwitcher> -->
              <img height="20" src="../assets/help.png" />
            </div>
            <div class="header-item menu-header-separator"></div>
            <div class="header-item">
              <!-- <langSwitcher></langSwitcher> -->
              <img height="20" src="../assets/search2.png" />
            </div>
            <div class="header-item">
              <!-- <langSwitcher></langSwitcher> -->
              <!-- <img height="20" src="../assets/search2.png" />   -->
              <form class="d-flex">
                <input
                  class="form-control me-2"
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import langSwitcher from "./langSwitcher.vue";

export default {
  components: {
    langSwitcher,
  },

  computed: {
    myBgColorStyle: function () {
      return {
        backgroundColor: "#030f40",
      };
    },

    myTxtColorStyle: function () {
      return {
        color: "#D95D2C",
      };
    },

    logoSrc: function () {
      return null;
    },
  },

  methods: {
    goMenu: function () {
      // this.$store.dispatch('goMenu');
    },
  },
};
</script>
<style lang="scss" scoped>
$bloc-background-color: #fff;
$dinProM: "D-DIN", "ropaSanRegular", sans-serif;
$font-dark-color: #030f40;

header.main-header {
  // float: left;
  width: 100%;
  background: $font-dark-color;
  font-family: $dinProM;
  color: #fff;
  min-width: 320px;
  height: 50px;
  padding-left: 15px;
  padding-right: 15px;
  box-shadow: 0px 4px 4px $bloc-background-color;
  font-size: 15px;
  //  position: fixed;
  // z-index: 0.1;
}

header.main-header div.container-fluid .header-links {
  text-align: right;
}

header ul.inline li {
  display: inline-block;
  padding: 0 5px;
}

.main-header .row {
  margin-right: 0px;
  margin-left: 0px;
}

.header-item {
  text-align: center;
  width: auto;
  float: right;
  height: 24px;
  line-height: 24px;
  margin-top: 12px;
  padding-right: 10px;
}

.header-item-left {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-block;
  float: left;
}

.header-item-left-menu {
  margin-right: 15px;
  cursor: pointer;
}

.header-item select {
  width: auto;
  display: inline;
}

.header-item a,
.header-item a:hover {
  color: #fff;
  text-decoration: inherit;
}

.header-logo {
  margin-top: 10px;
  width: 150px;
}

//   .header-controls {}

.menu-img {
  height: 50px;
  display: table-cell;
  vertical-align: middle;
}

.menu-header-separator {
  border-left: 1px solid #030f40;
  padding-left: 11px;
}
.me-2 {
  height: 25px;
}
</style>
